import callApi, { BaseResponse, BaseResponseDto, BaseResponsePagedDto } from "./baseRequest"

const route = 'banking-account';

export function getEmptyBankAccount(): BankAccount {
    return {
        agency: ``,
        bank: ``,
        companyDocument: ``,
        companyName: ``,
        createdAt: undefined,
        createdBy: ``,
        currentAccount: ``,
        enabled: undefined,
        id: ``,
        modifiedAt: undefined,
        modifiedBy: ``,
        pixKey: ``,
        pixKeyType: 0,
        usefulLinksGroupEntityId: ``,
        country: ``
    }
}


export interface BankAccount {
    agency: string,
    bank: string,
    companyDocument: string,
    companyName: string,
    createdAt?: Date,
    createdBy: string,
    currentAccount: string,
    enabled?: boolean,
    id: string,
    modifiedAt?: Date,
    modifiedBy: string,
    pixKey: string,
    pixKeyType: number,
    usefulLinksGroupEntityId: string,
    country: string
};

export type BankingAccountPost = Pick<BankAccount, 'agency' | 'bank' | 'companyDocument' | 'companyName' | 'createdBy' | 'currentAccount' | 'pixKey' | 'pixKeyType' | 'usefulLinksGroupEntityId' | 'usefulLinksGroupEntityId' | 'enabled'>;
export type BankingAccountPut = Pick<BankAccount,  'id'| 'agency' | 'bank' | 'companyDocument' | 'companyName' | 'modifiedBy' | 'currentAccount' | 'pixKey' | 'pixKeyType' | 'usefulLinksGroupEntityId' | 'enabled' | 'usefulLinksGroupEntityId'>;


export function getBankingAccounts(language: string, take: number, skip: number, search?: string, country?: string, enabled?: string) : Promise<BaseResponsePagedDto<BankAccount[]>>{
    const result: BaseResponsePagedDto<BankAccount[]> = {
        data: [],
        success: false,
        error: '',
        totalItems: 0,
        totalPages: 0,
        currentTake: take
    }

    const response = callApi('GET', `${route}/get-all/?take=${take}&skip=${skip}&search=${search}&countryId=${country}&enabled=${enabled}&language=${language}`)
        .then(resp => {
            if(resp?.data.length > 0 ?? false){
                result.data = resp?.data;
                result.totalPages = resp.totalPages;
                result.totalItems = resp.totalItems;
                result.success = true;
            }
            else{
                result.error = 'An error occurred.'
            }
            return result;
        })
        .catch(err => {
                return result;
        })

        return response;
}

export function getBankingAccountById(id: string, language: string):Promise<BaseResponseDto<BankAccount>> {
    const result: BaseResponseDto<BankAccount> = {
        data: getEmptyBankAccount(),
        success: false,
        error: '',
    };

    const response = callApi('GET', `${route}/get/${id}/${language}`)
    .then(resp => {
        if (resp?.data ?? false) {
            result.data = resp?.data;
            result.success = true;
        }
        else {
            result.error = 'Erro ao buscar o Informativo';
        }

        return result;
    })
    .catch(err => {
        result.error = err;
        return result;
    })

    return response;
}

export function createBankingAccount(bankingAccount: BankingAccountPost): Promise<BaseResponseDto<any>> {
    const result: BaseResponseDto<any> = {
        error: '',
        success: false,
        data: null,
    };
    const response = callApi('POST', `${route}/create`, bankingAccount).then(response => {
            result.success = true;
            if (response.data) {
                result.success = true;
                result.data = response.data
            }
            return result;
        }).catch(err => {
            result.error = err.error;

            return result;
        });

    return response;
}

export function updateBankingAccount(bankingAccount: BankingAccountPut, id: string): Promise<BaseResponseDto<any>> {
    const result: BaseResponseDto<any> = {
        error: '',
        success: false,
        data: null,
    };

    const response = callApi('PUT', `${route}/update/${id}`, bankingAccount)
        .then(response => {
            result.success = true;
            if (response.data) {
                result.success = true;
                result.data = response.data
            }
            return result;
        })
        .catch(err => {
            result.error = err.error;
            return result;
        });
    return response;
}